// extracted by mini-css-extract-plugin
export default {"hover_cards":"Cards_hover_cards__ISAY8","container":"Cards_container__vfogQ","card1":"Cards_card1__tAE9S","box":"Cards_box__zB3Ct","content":"Cards_content__U0R+l"};